// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"afde4609","383":"78ee7d5d","400":"609ccc29","632":"c0b7c6df"}[chunkId] + ".chunk.js";
};